function setStocksByLocations(data) {
	return {
		type: 'SET_STOCKS_BY_LOCATIONS',
		payload: data,
	};
}

export { setStocksByLocations };
